import React from 'react';
import PropTypes from 'prop-types';
import { onlyUpdateForKeys } from 'recompose';
import styled, { keyframes } from 'styled-components';

const clip = keyframes`
  0% {transform: rotate(0deg) scale(1)} 
  50% {transform: rotate(180deg) scale(0.8)}
  100% {transform: rotate(360deg) scale(1)}
`;

const Partial = styled.div`
    background: transparent !important;
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    border-radius: 100%;
    border: 2px solid;
    border-color: ${(props) => props.color};
    border-bottom-color: transparent;
    display: inline-block;
    animation: ${clip} 0.75s 0s infinite linear;
    animation-fill-mode: both;
`;

class Loader extends React.Component {
    render() {
        const { size, qaId } = this.props;
        return this.props.loading ? (
            <Partial size={size} index="0" data-qa-id={`${qaId}-spinner`} />
        ) : null;
    }
}

Loader.propTypes = {
    loading: PropTypes.bool,
    color: PropTypes.string,
    size: PropTypes.number,
    qaId: PropTypes.string,
};

Loader.defaultProps = {
    loading: true,
    color: '#000000',
    size: 50,
};

const Component = onlyUpdateForKeys(['loading', 'color', 'size'])(Loader);
Component.defaultProps = Loader.defaultProps;
export default Component;
